import { alpha } from '@mui/material/styles';
import {
     MODERN_BACKDROP,
     MODERN_SHADOWS,
     MODERN_TRANSITIONS
} from '../styles/modernVariables';
import { ICustomTheme } from '../types/ICustomTheme';

export const getDialogStyles = (themeOptions: ICustomTheme) => ({
     styleOverrides: {
          root: {
               '& .MuiBackdrop-root': {
                    backdropFilter: MODERN_BACKDROP.glass,
                    backgroundColor: themeOptions.palette.mode === 'dark' 
                         ? 'rgba(0, 0, 0, 0.6)' 
                         : 'rgba(0, 0, 0, 0.4)',
                    transition: MODERN_TRANSITIONS.smooth,
               },
          },          paper: ({ theme }: { theme: any }) => ({
               borderRadius: '4px', // 4px conforme solicitado
               boxShadow: MODERN_SHADOWS.elevation[5],
               transition: MODERN_TRANSITIONS.smooth,
               position: 'relative' as const,
               overflow: 'hidden' as const,
               
               // Glassmorphism para diálogos
               backgroundColor: theme.palette.mode === 'dark' 
                    ? alpha(theme.palette.background.paper, 0.95)
                    : alpha(theme.palette.background.paper, 0.98),
               backdropFilter: 'blur(20px)',
               border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
               
               // Brilho sutil no topo
               '&::before': {
                    content: '""',
                    position: 'absolute' as const,
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '1px',
                    background: `linear-gradient(90deg, transparent, ${alpha(theme.palette.primary.main, 0.6)}, transparent)`,
                    opacity: 0.8,
               },
               
               // Animação de entrada suave
               animation: 'dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
               
               '@keyframes dialogSlideIn': {
                    '0%': {
                         opacity: 0,
                         transform: 'scale(0.8) translateY(20px)',
                    },
                    '100%': {
                         opacity: 1,
                         transform: 'scale(1) translateY(0)',
                    },
               },
          }),
     },
});

export const getDialogActionsStyles = (_themeOptions: ICustomTheme) => ({
     styleOverrides: {
          root: ({ theme }: { theme: any }) => ({
               backgroundColor: 'transparent',
               borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
               padding: '16px 24px',
               gap: '12px',
               
               // Glassmorphism sutil
               backdropFilter: 'blur(8px)',                 '& .MuiButton-root': {
                    borderRadius: '2px', // 2px conforme solicitado
                    fontWeight: 500,
                    padding: '8px 20px',
                    color: theme.palette.text.secondary,
                    transition: MODERN_TRANSITIONS.smooth,
                    '&:hover': {
                         color: theme.palette.text.primary,
                    },
               },
          }),
     },
});

export const getDialogTitleStyles = (_themeOptions: ICustomTheme) => ({
     styleOverrides: {
          root: ({ theme }: { theme: any }) => ({
               backgroundColor: 'transparent',
               borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
               padding: '24px 24px 16px',
               fontWeight: 600,
               fontSize: '1.25rem',
               
               // Glassmorphism sutil
               backdropFilter: 'blur(8px)',
          }),
     },
});

export const getDialogContentStyles = (_themeOptions: ICustomTheme) => ({
     styleOverrides: {
          root: {
               backgroundColor: 'transparent',
               padding: '20px 24px',
          },
     },
});

export const getTooltipStyles = (_themeOptions: ICustomTheme) => ({
     styleOverrides: {
          tooltip: ({ theme }: { theme: any }) => ({
               backgroundColor: theme.palette.mode === 'dark' 
                    ? alpha(theme.palette.background.paper, 0.95)
                    : alpha(theme.palette.background.paper, 0.98),
               color: theme.palette.text.primary,               fontSize: '0.775rem',
               fontWeight: 500,
               borderRadius: '2px', // 2px conforme solicitado
               padding: '10px 14px',
               boxShadow: MODERN_SHADOWS.elevation[3],
               backdropFilter: 'blur(12px)',
               border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
               
               // Animação suave de entrada
               animation: 'tooltipSlideIn 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
               
               '& .MuiTooltip-arrow': {
                    color: theme.palette.mode === 'dark' 
                         ? alpha(theme.palette.background.paper, 0.95)
                         : alpha(theme.palette.background.paper, 0.98),
               },
               
               '@keyframes tooltipSlideIn': {
                    '0%': {
                         opacity: 0,
                         transform: 'scale(0.9) translateY(4px)',
                    },
                    '100%': {
                         opacity: 1,
                         transform: 'scale(1) translateY(0)',
                    },
               },
          }),
     },
});
